import { InvoiceResponse } from '@/types/service-response'
import { Invoicing } from '@/model/planning/Invoicing'

export class Invoice {
  private constructor (
    readonly invoicing: Invoicing[],
    readonly notInvoicing: Invoicing[]
  ) {}

  public static createFromResponse (data: InvoiceResponse): Invoice {
    return new Invoice(
      Invoicing.createListFromResponse(data.ToFakturierung),
      Invoicing.createListFromResponse(data.NichtFakturierung)
    )
  }
}
